<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Cumplimiento de entrega</h1>
                <div class="caption">
                    Descripción: Muestra la cantidad de pedidos con entrega en fecha y entrega fuera de fecha en función del
                    tipo de fecha seleccionada.
                    Fecha prevista de entrega: muestra el cumplimiento de los ítems con fecha de entrega pactada para el
                    mes correspondiente.
                    Fecha real: muestra el cumplimiento de los ítems ya entregados.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <moneda-select v-model="d.moneda"></moneda-select>
                        <v-select :items="tipos" v-model="d.tipo" label="Tipo fecha"></v-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-checkbox label="¿Traer datos de OPI?" v-model="d.opi"></v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="datos()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
        <v-menu
                v-model="seriesShow"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
                min-width="500"
        >
            <v-card raised>
                <v-card-text>
                    <highcharts style="width: 100%" :options="chartSeriesOptions"></highcharts>
                </v-card-text>
            </v-card>
        </v-menu>
    </v-container>
</template>
<script>
    import {mapActions} from 'vuex';
    import empresaSelect from '../../components/EmpresaSelect';
    import monedaSelect from '../../components/MonedaSelect';
    import moment from 'moment';

    export default {
        components: {empresaSelect, monedaSelect},
        data() {
            return {
                seriesShow: false,
                x: 0,
                y: 0,
                seriesTit: '',
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                monedas: [],
                tipos: [
                    {value: 'real', text: 'Fecha de Entrega Real'},
                    {value: 'prevista', text: 'Fecha de Entrega Prevista'},
                ],
                d: {
                    tipo: 'real',
                    empresa: '',
                    moneda: '',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                    opi: false
                },
                chartOptions: {
                    colors: ['#3b9d3b', '#D62C1A', '#ffdd32'],
                    chart: {
                        backgroundColor: '',
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'CUMPLIMIENTO DE ENTREGA'
                    },
                    legend: {
                        labelFormat: '{name}'
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.1f}</b>'
                    },
                    xAxis: {
                        type: 'category',
                        title: {
                            text: 'Items'
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            },
                            format: '$ {total:,.2f}'
                        }
                    },
                    plotOptions: {
                        column: {
                            stacking: 'normal',
                            dataLabels: {
                                enabled: true,
                                color: '#ffffff',
                                style: {
                                    textShadow: '0 0 3px black, 0 0 3px black'
                                },
                                format: '{y}({point.percentage:.0f}%)'
                            }
                        },
                        series: {
                            point: {
                                events: {
                                    click: (e) => {
                                        console.log(e);
                                        this.x = e.x;
                                        this.y = e.y;
                                        this.seriesTit = e.point.name;
                                        this.traeSeries(e.point.ano, e.point.mes, e.point.name, e.point.serie)
                                    }
                                }
                            }
                        }
                    },
                    series: []
                },
                chartSeriesOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'DESPACHOS POR SERIE'
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.1f}</b>'
                    }
                    ,
                    xAxis: {
                        type: 'category',
                        title:
                            {
                                text: 'Series'
                            }
                    }
                    ,
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        }
                        ,
                        stackLabels: {
                            enabled: true,
                            style:
                                {
                                    fontWeight: 'bold',
                                    color:
                                        'gray'
                                }
                            ,
                            format: '$ {total:,.2f}'
                        }
                        ,
                    }
                    ,
                    plotOptions: {
                        column: {
                            stacking: false,
                            grouping:
                                true,
                            dataLabels:
                                {
                                    enabled: true,
                                    format:
                                        '{y}'
                                }
                        }
                    }
                    ,
                    series: []
                }
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            datos() {
                this.loading = true;
                this.$http.post('indicadores/entrega', this.d)
                    .then(r => {
                        this.chartOptions.series = r.data.datos;
                        this.loading = false;
                        this.lateral = false;
                    })
                    .catch(err => {
                        this.msjShow({txt: 'Error al intentar obtener datos', tipo: 'error'});
                        this.loading = false;
                    })
            },
            traeSeries(ano, mes, name, serie) {
                this.loading = true;
                this.$http.post('indicadores/entrega-series', {
                    ano: ano,
                    mes: mes,
                    name: name,
                    serie: serie,
                    empresa: this.d.empresa,
                    opi: this.d.opi,
                    tipo: this.d.tipo
                })
                    .then(r => {
                        this.chartSeriesOptions.series = r.data;
                        this.chartSeriesOptions.title.text = 'Cumplimiento por deposito ' + this.seriesTit;
                        this.$nextTick(() => {
                            this.seriesShow = true
                        })
                        this.loading = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/entrega.vue